import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Rooms from '../components/Rooms';
import NearbyPlaces from '../components/NearbyPlaces';
import Gallery from '../components/Gallery';
import Location from '../components/Location';
import Footer from '../components/Footer';
import BookingModal from '../components/BookingModal';

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  const handleBookNow = (room) => {
    setSelectedRoom(room);
    setIsModalOpen(true);
  };

  return (
    <div>
      <Navigation />
      <Hero onBookNow={() => handleBookNow(null)} />
      <About />
      <Rooms onBookNow={handleBookNow} />
      <NearbyPlaces />
      <Gallery />
      <Location />
      <Footer />
      <BookingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedRoom={selectedRoom}
      />
    </div>
  );
};

export default HomePage;
